import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AlertBell } from '@yme/assets/icons';
import { SpinnerLoader } from '@yme/atoms/spinner-loader';
import { ICON_SIZE } from '@yme/atoms/svg-icon';
import { setIsNotifyMeLoaded, getIsNotifyMeLoaded } from '@yme/pdp-components/ProductCard';
import { getRootLang } from '@yme/selectors/common';
import { colorBlackTransparent50 } from '@yme/tokens/colors';
import { DigitalDataMutation, getFormattedLanguageRoot, setDigitalData } from '@yme/utils/common';
import { ResponseModalWindows } from '../ResponseModalWindows';
import { FAILED_TYPE, INPUT_TYPE, NOTIFY_ME_VARIANTS, SUCCESS_TYPE } from '../constants';
import { setBackInStockNotification } from '../services';
import { MiniButtonStyled } from '../styled';
import { NotifyMeBackInStockModal } from './NotifyMeBackInStockModal';
export function NotifyMeBackInStockButton({ isRightToLeft, labels, variantSku, isButtonView, }) {
    const [stateForm, setStateForm] = useState(null);
    const [formData, setFormData] = useState({
        email: '',
    });
    const [isActive, setIsActive] = useState(false);
    const isLoading = useSelector(getIsNotifyMeLoaded);
    const rootLanguage = useSelector(getRootLang);
    const formattedRootLanguage = getFormattedLanguageRoot(rootLanguage);
    const linkToProduct = window.location.pathname;
    const payload = useMemo(() => ({
        email: formData?.email?.toLowerCase(),
        sku: variantSku,
        link: linkToProduct,
        language: formattedRootLanguage,
    }), [formData, formattedRootLanguage, linkToProduct, variantSku]);
    const { notifyMeGetNotifiedLink, notifyMeButton } = labels;
    const dispatch = useDispatch();
    const onSwitchType = (type) => {
        setIsActive(true);
        setStateForm(type);
    };
    const onSubmitActionHandler = () => {
        dispatch(setIsNotifyMeLoaded(true));
        setBackInStockNotification(payload, onSwitchType, dispatch);
    };
    const onHideModal = () => {
        setStateForm(null);
    };
    useEffect(() => {
        if (stateForm !== INPUT_TYPE) {
            return;
        }
        setDigitalData(DigitalDataMutation.NOTIFY_ME_ENTRY, {
            sku: variantSku,
        });
    }, [stateForm, variantSku]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SpinnerLoader, { isLoading: isLoading, fullWidth: true }),
        React.createElement(MiniButtonStyled, { onClick: () => onSwitchType(INPUT_TYPE), isButtonView: isButtonView, isUnderlined: !isButtonView, bgStyle: isButtonView ? colorBlackTransparent50 : undefined, isPaddingsReset: isButtonView, iconSize: ICON_SIZE.xs, iconType: isButtonView ? AlertBell : undefined, contentColor: "inherit" }, isButtonView ? notifyMeButton : notifyMeGetNotifiedLink),
        stateForm === INPUT_TYPE && (React.createElement(NotifyMeBackInStockModal, { labels: labels, onHideModal: onHideModal, onSubmitAction: onSubmitActionHandler, isRightToLeft: isRightToLeft, setFormData: setFormData, isActive: isActive, setIsActive: setIsActive })),
        (stateForm === SUCCESS_TYPE || stateForm === FAILED_TYPE) && (React.createElement(ResponseModalWindows, { labels: labels, emailText: formData.email, isSuccessStatus: stateForm === SUCCESS_TYPE, onHideModal: onHideModal, isRightToLeft: isRightToLeft, notifyMeType: NOTIFY_ME_VARIANTS.backInStock }))));
}
